/**
 * Check if two ContractCode instances are equal
 *
 * @param {import('./ContractCodeType.js').ContractCodeType} a - First ContractCode
 * @param {import('./ContractCodeType.js').ContractCodeType} b - Second ContractCode
 * @returns {boolean} true if equal
 * @example
 * ```javascript
 * import * as ContractCode from './primitives/ContractCode/index.js';
 * const code1 = ContractCode.from("0x6001");
 * const code2 = ContractCode.from("0x6001");
 * ContractCode._equals(code1, code2); // true
 * ```
 */
export function equals(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		if (a[i] !== b[i]) return false;
	}
	return true;
}
